import '/assets/styles/main.pcss';

import LazyLoad from 'vanilla-lazyload';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';

import { blockRevealFullX } from './components/animations/blockRevealFullX';
import initHowItWorks from './components/animations/howItWorks';
import { imageMaskTranslateX } from './components/animations/imageMaskTranslateX';
import gridFadeIn from './components/animations/gridFadeIn';

import { articlesSlider } from './components/sliders/articles';
import { imageSimpleSlider } from './components/sliders/imageSimple';
import { videosSlider } from './components/sliders/videos';
import { testimonialsSlider } from './components/sliders/testimonials';
import { bannerImageText } from './components/blocks/bannerImageText';
import { columns2TextImagePin } from './components/blocks/columns2TextImagePin';
import { footerRevealFullX } from './components/blocks/footerRevealFullX';
import { headerNavReveal } from './components/blocks/headerNavReveal';
import { headerThemeColor, buttonStickyBottomThemeColor } from './components/blocks/headerThemeColor';
import { heroImage } from './components/blocks/heroImage';
import { highlightCategories } from './components/blocks/highlightCategories';
import { imageFullWidthWithBox } from './components/blocks/imageFullWidthWithBox';
import { cardsStack } from './components/blocks/cardsStack';
import { industryCardsStack } from './components/blocks/industryCardsStack';
import { siteMobileNav } from './components/blocks/siteMobileNav';
import { initStickyBlock } from './components/blocks/stickyBlock';
import { tilesProducts } from './components/blocks/tilesProducts';
import expandableBody from './components/expandableBody';
import initTeams from './components/teams';
import initTimeline from './components/timeline';
import initMap from './components/whatWeDoMap';
import jobForm from './components/forms/jobForm';
import iotInterestedForm from './components/forms/iotInterested';
import accessibilityForm from './components/forms/accessibilityForm';
import iotSliderHybrid from './components/blocks/iotSliderHybrid';
import iotHeroBanner from './components/blocks/iotHeroBanner';
import iotPowerOfOne from './components/blocks/iotPowerOfOne';
import iotEmpowering from './components/blocks/iotEmpowering';
import contactForm from './components/forms/contactForm';
import accordions from './components/accordions';

import { setExternalLink } from './utils/url';
import { initGtmCta } from './utils/gtm';
import { scrollToAnchor } from './utils/scrollToAnchor';
import { alertBanner } from './components/blocks/alertBanner';
import mobileWorldCongress2025MarchForm from './components/forms/mobileWorldCongress2025MarchForm';
import oembedAddFrame from './components/oembedAddFrame';

import headerDesktopSubmenu from './components/blocks/headerDesktopSubmenu';
import coverageCategories from './components/blocks/coverageCategories';

window.lazyloadInstance = new LazyLoad();

Alpine.data('headerDesktopSubmenu', headerDesktopSubmenu);
Alpine.data('coverageCategories', (categories) => coverageCategories(categories));

Alpine.plugin(focus);
Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
  oembedAddFrame();
  imageMaskTranslateX();
  blockRevealFullX();
  siteMobileNav();
  articlesSlider();
  imageSimpleSlider();
  videosSlider();
  testimonialsSlider();
  alertBanner();

  setTimeout(() => {
    setExternalLink();

    iotHeroBanner();
    iotPowerOfOne();
    iotSliderHybrid();
    iotEmpowering();
    gridFadeIn();
  }, 100);
});

window.addEventListener('load', () => {
  initMap();
  heroImage();
  footerRevealFullX();
  initTimeline();
  initTeams();
  initStickyBlock();
  initHowItWorks();
  bannerImageText();
  expandableBody();
  imageFullWidthWithBox();
  tilesProducts();
  accordions();
  cardsStack();
  industryCardsStack();
  columns2TextImagePin();
  highlightCategories();
  jobForm();
  iotInterestedForm();
  headerThemeColor();
  buttonStickyBottomThemeColor();
  headerNavReveal();
  accessibilityForm();
  mobileWorldCongress2025MarchForm();
  contactForm();

  setTimeout(() => {
    scrollToAnchor();
  }, 1);

  initGtmCta();
});
